/* eslint-disable no-restricted-syntax */
/* eslint-disable no-param-reassign */
/* eslint-disable guard-for-in */
/* eslint-disable no-console */
/* eslint-disable no-underscore-dangle */
import { apiClient, handleResponse } from './axios';

async function addElearningDetails(body) {
  try {
    const response = await apiClient
      .post('/elearningdetails/', body);
    const groups = await handleResponse(response);
    return groups;
  } catch (error) {
    return error.response;
  }
}

async function removeSubGroup(subgroupId, elearningId) {
  try {
    const response = await apiClient
      .put(`/elearningdetails/subgroup/remove/${elearningId}/${subgroupId}`);
    const elearningDetailss = await handleResponse(response);
    return elearningDetailss;
  } catch (error) {
    return error.response;
  }
}

async function getAllElearningDetails() {
  try {
    const response = await apiClient
      .get('/elearningdetails');
    const elearningDetailss = await handleResponse(response);
    return elearningDetailss;
  } catch (error) {
    return error.response;
  }
}

async function getElearningDetails(elearningId) {
  try {
    const response = await apiClient
      .get(`/elearningdetails/${elearningId}`);
    const elearningDetails = await handleResponse(response);
    return elearningDetails;
  } catch (error) {
    return error.response;
  }
}

async function getElearningDetailWithStudents(examId) {
  const response = await apiClient
    .get(`/elearningdetails/groups/${examId}`);
  const elearningDetails = await handleResponse(response);
  return elearningDetails;
}

async function updateElearningDetails(elearningId, body) {
  try {
    const response = await apiClient
      .put(`/elearningdetails/${elearningId}`, body);
    const elearningDetails = await handleResponse(response);
    return elearningDetails;
  } catch (error) {
    return error.response;
  }
}

async function updateResources(elearningId, body) {
  try {
    const response = await apiClient
      .put(`/elearningdetails/resources/${elearningId}`, body);
    const elearningDetails = await handleResponse(response);
    return elearningDetails;
  } catch (error) {
    return error.response;
  }
}

async function updateElearningDetailsExam(elearningId, semester, companyId, body) {
  try {
    const response = await apiClient
      .put(`/elearningdetails/exam/${elearningId}/${semester}/${companyId}`, body);
    const elearningDetails = await handleResponse(response);
    return elearningDetails;
  } catch (error) {
    return error.response;
  }
}

async function deleteElearningDetails(elearningId, body) {
  try {
    const response = await apiClient
      .delete(`/elearningdetails/${elearningId}`, body);
    const elearningDetails = await handleResponse(response);
    return elearningDetails;
  } catch (error) {
    return error.response;
  }
}

async function updateElearningOption(examId, body) {
  try {
    const response = await apiClient
      .post(`/elearningdetails/update/exam/${examId}`, body);
    const elearningDetails = await handleResponse(response);
    return elearningDetails;
  } catch (error) {
    return error.response;
  }
}

async function getJSONResultsByStudent(userId, companyId, semester) {
  try {
    const response = await apiClient
      .get(`/export/json/student/${userId}/${companyId}/${semester}`);
    const res = await handleResponse(response);
    return res;
  } catch (error) {
    return error.response;
  }
}

async function getElearningDetailsByCompany(body) {
  try {
    const response = await apiClient
      .post('/elearningdetails/company', body);
    const elearningDetails = await handleResponse(response);
    return elearningDetails;
  } catch (error) {
    return error.response;
  }
}

const elearningDetailsServices = {
  addElearningDetails,
  updateElearningDetails,
  getElearningDetails,
  getAllElearningDetails,
  deleteElearningDetails,
  removeSubGroup,
  getJSONResultsByStudent,
  updateElearningOption,
  updateElearningDetailsExam,
  updateResources,
  getElearningDetailsByCompany,
  getElearningDetailWithStudents,
};

export default elearningDetailsServices;
